//@TODO - Refactor once CPM-379 has been merged and fix multiple selection

class AssetBrowser {

    constructor() {

        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            templateUrl: 'asset-browser.html',
            scope: {
                asset: "=",
                selectedAssets: "=?",
                types: "=",
                folder: "=",
                multiple: "@?",
                droppable: "@?",
                isDraggable: "<",
                view: "@?"
            },
            controller: ($scope, $element, FolderService, AssetService, UserService, $routeParams, CONTENT_TYPE, EVENTS, $uibModal, $q, $rootScope, ApiService, $filter, SERVICE_LOCATIONS) => {
                
                $scope.retreivedFolders = {};
                $scope.typeAheadValues = {};
                this.SERVICE_LOCATIONS = SERVICE_LOCATIONS;

                if(!!$scope.droppable) {
                    $scope.droppable = $scope.droppable == 'true';
                } 
                else {
                    $scope.droppable = false;
                }

                if(!(!!$scope.view)) {
                    $scope.view = "thumbs";
                }

                if(typeof $scope.multiple === "undefined" || $scope.multiple === null) {
                    $scope.multiple = false;
                }
                else {
                    this.multiple = $scope.multiple == 'true';
                }

                this.$q = $q;
                this.FolderService = FolderService;
                this.AssetService = AssetService;
                this.CONTENT_TYPE = CONTENT_TYPE;
                this.EVENTS = EVENTS;
                this.ApiService = ApiService;
                $scope.rootFolderId = null;
                $scope.selectAnother = false;
                $scope.folders = [];
                $scope.foldersLoading = false;
                $scope.assetsLoading = false;
                $scope.subFoldersLoading = false;
                $scope.filter = {};

                $scope.asset = $scope.multiple ? $scope.asset = [] : $scope.asset = null;

                $scope.folder = null;
                $scope.selectedAssets = [];
                $scope.selectedAssetElements = [];
                if(!!$scope.view) {
                    $scope.view = "list";
                }

                for(let i = 0; i < 3; i++) {
                    $scope.folders.push({
                        folder: null,
                        subFolders: null,
                        assets: null
                    });
                }

                $('.asset-browser-container').last().prependTo('.container');

                if($scope.droppable) {

                    $element.on("dragenter", (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                    });

                    $element.on("dragover", function(ev) {
                        ev.stopPropagation();
                        ev.preventDefault();
                    });

                    $element.on("dragleave", function(ev) {
                        ev.stopPropagation();
                        ev.preventDefault();

                    });

                    $element.on("drop", (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        let files = ev.originalEvent.dataTransfer.files;
                        $scope.showUploadPanel(files);
                    });

                }

                $scope.$on("asset_created", () => {
                    if(!!$scope.folders[1].folder.id) {               
                        $scope.getFolderAssets($scope.folders[1].folder.id, 1);
                    }
                });

                $scope.loadContents = (folderId, idx, filterExpression = "*", searchExpression = "*") =>{

                    $scope.foldersLoading = $scope.subFoldersLoading = $scope.assetsLoading = true;
                    let requests = [this.FolderService.getFolder(folderId), this.FolderService.getSubfolders(folderId), this.FolderService.searchOrFilterFolder(folderId, filterExpression, searchExpression)];
                    this.$q.all(requests).then(response => {
                        
                        $scope.folders[idx].folder = response[0].data;
                        $scope.folders[idx].subFolders  = response[1].data;
                        let folderListing = response[2].data;

                        $scope.folders[idx].assets = [];
                        $.each(folderListing.assets, (ix, asset) => {
                            if($scope.containsAssetType(asset)) {
                                $scope.folders[idx].assets.push(asset);
                            }
                        });
                        let folderString = JSON.stringify(response[0].data);
                        if(idx === 1) {
                            localStorage.setItem("cpm.prevLocation", folderString);
                            if(!$scope.folder) {
                                $scope.folder = response[0].data;
                            }
                            $scope.setTypeaheadValues();
                        }

                        $scope.retreivedFolders[folderId] = $scope.folders[idx];
                        $scope.foldersLoading = $scope.subFoldersLoading = $scope.assetsLoading = false;
                    }); 
                };

                $scope.rootFolderId = $rootScope.currentUser.rootFolder;
                if(!!localStorage.getItem("cpm.prevLocation")) {
                    let folder = JSON.parse(localStorage.getItem("cpm.prevLocation"));
                    if(folder.hasOwnProperty("id")) {
                        $scope.folder = folder;
                        $scope.loadContents(folder.id, 1);
                    }
                    else {
                        $scope.loadContents($scope.rootFolderId, 1);
                    }
                }
                else {
                    $scope.loadContents($scope.rootFolderId, 1);
                }

                $scope.getFolderAssets = (folderId, idx, filterExpression = "*", searchExpression = "*") => {
                    this.FolderService.searchOrFilterFolder(folderId, filterExpression, searchExpression)
                        .then((response) => {
                            let assets = [];
                            $.each(response.data.assets, (ix, asset) => {
                                if($scope.containsAssetType(asset)) {
                                    assets.push(asset);
                                }
                            });
                            $scope.folders[idx].assets = assets;
                            $scope.retreivedFolders[folderId].assets = assets;
                            $scope.assetsLoading = false;
                        }, (response) => {
                            $scope.assetsLoading = false;
                        });
                };

                $scope.showPreviousFolder = () => {
                    $scope.loadContents($scope.folders[1].folder.parentId, 1);
                    $scope.shiftRight();
                };

                $scope.shiftRight = () => {
                    $('.inner-container').animate({
                        left: + 300
                    }, 400, function () {
                        $('.asset-browser-container').last().prependTo('.inner-container');
                        $('.inner-container').css('left', '');
                    });
                };

                $scope.shiftLeft = () => {
                    $('.inner-container').animate({
                        left: - 300
                    }, 400,  () => {
                        $('.asset-browser-container ').first().appendTo('.inner-container');
                        $('.inner-container').css('left', ''); 
                    });
                };

                $scope.selectFolder = (folder) => {
                    $scope.setAsLoading();
                    $scope.folder = folder;
                    $scope.filter = {};

                    $('.inner-container').animate({
                        left: - 300
                    }, 400,  () => {
                        $('.asset-browser-container').first().appendTo('.inner-container');
                        $('.inner-container').css('left', ''); 

                        let folderId = folder.id;

                        $scope.folders[1] = {
                            assets: null,
                            folder: null,
                            subFolders: null
                        };

                        $scope.loadContents(folderId, 1);
                    });
                };

                $scope.selectAsset = (asset, $event) => {
                    let element = $($event.currentTarget);
                    element.removeClass('asset-selected');

                    if(this.multiple) {
                        if (!~$scope.asset.indexOf(asset)) {
                            $scope.asset.push(asset);
                            element.addClass('asset-selected');
                            $scope.selectedAssetElements.push(element);
                        } else {
                            $scope.asset.splice($scope.asset.indexOf(asset), 1);
                            element.removeClass('asset-selected');
                            $scope.selectedAssetElements.filter(el => el != element);
                        }
                    } else {
                        $scope.asset = asset;
                    }
                };

                $scope.setAsLoading = ()  => {
                    $scope.foldersLoading = true;
                    $scope.assetsLoading = true;
                    $scope.subFoldersLoading = true;
                };

                $scope.toggleSearch = () => {
                     $element.find(".search-filter").slideToggle('fast', () => {
                        //Account for the space consumed by the search filter
                         if($('.search-filter').is(':hidden')) {;
                             $('.folder-assets-list').css("max-height", "");  
                         }
                         else {
                             $('.folder-assets-list').css("max-height", "calc(100% - 150px)");  
                         }
                     });
                }

                $scope.containsAssetType = (asset) => {

                    //Checks if the asset's content type contains a substring of provided types. 
                    //Allows for partial matches such as image/ or video/. This should be done in a better way. 
                    let found = false;
                    for(let i = 0; i < $scope.types.length; i++) {
                        if(asset.contentType.indexOf($scope.types[i]) > -1) {
                            found = true;
                            break;
                        }
                    }
                    return found;
                };

                $scope.showUploadPanel = (files) => {
                    $scope.modalInstance = $uibModal.open({
                        controller: "FileUploadCtrl",
                        templateUrl: "file-uploader/file-upload.html",
                        windowClass: 'file-upload-index',
                        backdropClass: 'file-upload-backdrop-index',
                        resolve: { 
                            folderId: () => { return $scope.folders[1].folder.id; },
                            files: () => { return files; },
                            currentDirectoryListing: () => { return []; }
                        }
                    });

                    $scope.modalInstance.result.then((folder) => {
                        this.getFolderAssets($scope.folders[1].folder.id, 1);
                    }, () => {
                        
                    });
                };

                $scope.createFolder = () => {

                    $scope.modalInstance = $uibModal.open({
                        templateUrl: 'asset-library/create-folder.html',
                        controller: 'AddItemCtrl',
                        windowClass: 'file-upload-index',
                        backdropClass: 'file-upload-backdrop-index',
                        animation: true,
                        resolve: {
                        },
                        scope: $scope
                    });

                    $scope.modalInstance.result.then((folder) => {

                        var data = {
                            name: folder.name,
                            folderId: $scope.folders[1].folder.id,
                            parentId: $scope.folders[1].folder.id,
                            contentType: 'x-reflow/folder',
                            createdDate: new Date(),
                            lastModified: new Date()
                        };

                        this.ApiService.create(this.CONTENT_TYPE.FOLDER, data)
                            .then((response) => {
                                $scope.folders[1].subFolders.push(response.data);
                                $scope.selectFolder(response.data);
                            }, (response) => {

                            });

                    }, () => {
                        
                    });
                };

                $scope.setTypeaheadValues = () => {
                    let assetNames = $scope.folders[1].assets.map(f => f.name);
                    let folderNames = $scope.folders[1].subFolders.map(a => a.name);
                    $scope.typeAheadValues = [...assetNames, ...folderNames];
                }

                $scope.copyAssetPath = (asset) => {
                    try {
                        let el = document.createElement('textarea');
                        el.value = this.SERVICE_LOCATIONS.CDN_URL + asset.src;
                        el.setAttribute('readonly', '');
                        el.style.position = 'absolute';
                        el.style.left = '-9999px';
                        document.body.appendChild(el);
                        el.select();
                        document.execCommand('copy');
                        document.body.removeChild(el);
                        $scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Copied asset path to clipboard."})
                    }
                    catch(e) {
                        $scope.$emit(EVENTS.SHOW_NOTIFICATION, {'message': "Could not copy asset path to clipboard at this, your browser may not support this action. Please copy the path from the asset library instead.", messageType: "error"});
                        console.error(e);
                    }

                }

            },
            link: ($scope, $el, $attr) => {
            }
        };

    }

}

class DraggableAsset {

    constructor() {

        return {
            restrict: 'A',
            scope: {
                draggableAsset: "="
            },
            controller: ($scope, $element, FolderService, AssetService, UserService, $routeParams, CONTENT_TYPE, EVENTS) => {
                if($scope.draggableAsset) {
                    $element.draggable({
                        helper: "clone",
                        appendTo: "body",
                        containment: "document"
                    });
                    if($scope.draggableAsset.src.toLowerCase().endsWith(".woff") || $scope.draggableAsset.src.toLowerCase().endsWith(".woff2") || $scope.draggableAsset.src.toLowerCase().endsWith(".eot") || $scope.draggableAsset.src.toLowerCase().endsWith(".ttf")) {
                        $element.data("reflow-font", $scope.draggableAsset);
                        $element.addClass("template-font");
                    }
                    else {
                        $element.data("reflow-asset", $scope.draggableAsset);
                        $element.addClass("template-asset");
                    }
                    
                }
            }
        };

    }
}

angular.module('cpm')
    .directive('assetBrowser', [() => {
        'use strict';
        return new AssetBrowser();
    }]);

angular.module('cpm')
    .directive('draggableAsset', [() => {
        'use strict';
        return new DraggableAsset();
    }]);
